import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './lib/AuthContext'
import { GroupProvider } from './lib/GroupContext'
import App from './App.jsx'
import { initSentry, SentryErrorBoundary } from './lib/sentry'
import './index.css'

initSentry()

// Register the PWA service worker. We let it fail silently — without it
// the site still works, you just lose the install-to-home-screen prompt.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* ignore */ })
  })
}

function ErrorFallback() {
  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      padding: '24px',
      textAlign: 'center',
      color: '#fff',
      background: '#0a0a0a',
      fontFamily: 'Inter, system-ui, sans-serif',
    }}>
      <div style={{ fontSize: '40px' }}>🎬</div>
      <h1 style={{ fontSize: '20px', margin: 0 }}>Something broke.</h1>
      <p style={{ color: '#9ca3af', maxWidth: '320px', margin: 0 }}>
        We've been notified. Refresh to try again.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: '12px',
          padding: '12px 24px',
          background: '#c8102e',
          color: '#fff',
          border: 'none',
          borderRadius: '999px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />}>
      <BrowserRouter>
        <AuthProvider>
          <GroupProvider>
            <App />
          </GroupProvider>
        </AuthProvider>
      </BrowserRouter>
    </SentryErrorBoundary>
  </StrictMode>,
)
